const toRub = (array, priceKey = 'price') => (
  array.map((item) => ({ ...item, [priceKey]: item[priceKey] ? (item[priceKey] / 100).toFixed(2) : 0 }))
)

const fromRub = (array, priceKey = 'price') => (
  array.map((item) => ({ ...item, [priceKey]: item[priceKey] ? parseFloat(item[priceKey]) * 100 : 0 }))
)

const convertPrice = {
  fromRub,
  toRub,
}


export default convertPrice
